/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Auto_WrapInputs */



/**
* | output |
* | --- |
* | "Auto-wrap when the character limit is reached" |
*
* @param {Live_Caption_Auto_WrapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_auto_wrap = /** @type {((inputs?: Live_Caption_Auto_WrapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Auto_WrapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à la ligne automatique lorsque la limite de caractères est atteinte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatischer Zeilenumbruch bei Erreichen der Zeichengrenze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Andare a capo automaticamente al raggiungimento del limite di caratteri.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический перенос символов при достижении лимита символов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar automáticamente el texto cuando se alcance el límite de caracteres.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("达到字符限制时自动换行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文字数制限に達したら自動的に折り返す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अक्षर सीमा पूरी हो जाने पर स्वतः रैप हो जाएगा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quebra automática de linha quando o limite de caracteres for atingido.")
	return /** @type {LocalizedString} */ ("Auto-wrap when the character limit is reached")
});